module.exports = __webpack_public_path__ + "img/play-primary.b718d52e.svg";